import { createSelector } from 'reselect';

export const selectEarningsSnapshot = state => state.earningsSnapshot;

export const selectEarningsSnapshotConfig = createSelector(selectEarningsSnapshot, ({ config }) => config);
export const selectEarningsSnapshotIsLoaded = createSelector(selectEarningsSnapshot, ({ isLoaded }) => isLoaded);
export const selectEarningsSnapshotIsLoading = createSelector(selectEarningsSnapshot, ({ isLoading }) => isLoading);
export const selectEarningsSnapshotData = createSelector(selectEarningsSnapshot, ({ data }) => data);
